import React from "react";

export default function Soon() {
	return <div className="Soon">Sorry this page isn't available</div>;
}
